import { render, staticRenderFns } from "./aud-group-manage-detail.vue?vue&type=template&id=713cfa9a&scoped=true&"
import script from "./aud-group-manage-detail.vue?vue&type=script&lang=js&"
export * from "./aud-group-manage-detail.vue?vue&type=script&lang=js&"
import style0 from "./aud-group-manage-detail.vue?vue&type=style&index=0&id=713cfa9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713cfa9a",
  null
  
)

export default component.exports